/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class ExchangeRateDto {
  public sourceCurrencyCode: string = undefined;
  public targetCurrencyCode: string = undefined;
  public rate: number = undefined;

  //<custom-body>
  static convertEucToEur(code:string){
    if(code === "EUC") return "EUR"
    return code;
  }
  //</custom-body>
}
